import { render } from "./Search.vue?vue&type=template&id=00474c9a&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=00474c9a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-00474c9a"

export default script